import { Column } from "components/flexComponents/MultiColumnContainer/model/Column";
import { TwoColumn } from "components/flexComponents/MultiColumnContainer/decorators/TwoColumn/TwoColumn";

/**
 * Inverses the fallback/missing logic of a given two column. Examples:
 *
 * ------------
 * | 1     2  |
 * |          |
 * |       3  |
 * ------------
 *
 * If 1 is missing:
 * ------------
 * | 3     2  |
 * |          |
 * |          |
 * ------------
 *
 */
export class TwoColumnInverseFallback extends TwoColumn {
  public constructor(column: Column) {
    super(column) /* istanbul ignore next */;

    const twoColumn = this.wrappedColumn as TwoColumn;
    const { rightColumn, leftColumn } = twoColumn;

    // This does not support beyond 4 modules
    const shouldInverse = rightColumn.modules.length === 1 && leftColumn.modules.length === 1;

    if (shouldInverse) {
      this.setLeftAndRightColumn(rightColumn.modules, leftColumn.modules);
    } else {
      this.setLeftAndRightColumn(leftColumn.modules, rightColumn.modules);
    }
  }
}
